"use client"

import { Waypoints } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WaypointsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WaypointsIcon = component(Icon)({ as: Waypoints })
